import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { signInWithSsoToken } from '../../domain/Auth';
import { showErrorMessage } from '../../utils';

/**
 * Where auth-service sends the admin back after Google: `/auth/google?token=…`
 * on success, `?error=…` on failure. Renders nothing; the login screen sits
 * underneath it.
 *
 * The token carries the session's refresh token, so the URL is replaced with
 * `/` before anything else happens: it must not stay in this history entry or
 * be there for anything that reads the address bar afterwards.
 */
const SSOCallbackHandler = () => {
  const location = useLocation();
  const history = useHistory();
  // Read once, on arrival: replacing the URL below changes the location.
  const [{ token, error }] = useState(() => {
    const params = new URLSearchParams(location.search);
    return { token: params.get('token'), error: params.get('error') };
  });

  useEffect(() => {
    history.replace('/');

    if (error) {
      showErrorMessage({ message: error });
    } else if (token && !signInWithSsoToken(token)) {
      showErrorMessage({ message: 'Google sign-in failed. Please try again.' });
    }
  }, [history, token, error]);

  return null;
};

export default SSOCallbackHandler;
